import Dialog from '@mui/material/Dialog'
import Typography from '@mui/material/Typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBan,
  faCircleInfo,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons'
import { NoteV2 } from '@labrav/react-components'
import { AutoSubmitLimitNote } from './AutoSubmitLimitNote'
import { useStyles } from './AutoSubmitConfirmDialog.styles'

// TODO(funding): point at the real funding "Help & FAQs" article once it exists.
const HELP_URL = '#'

interface AutoSubmitConfirmDialogProps {
  open: boolean
  title: string
  /** One paragraph per line; caller controls the enable vs disable copy. */
  bodyLines: string[]
  /** The program's auto-submit limit, stated in the ribbon. */
  limitUsd?: string | null
  onCancel: () => void
  onProceed: () => void
}

export const AutoSubmitConfirmDialog = ({
  open,
  title,
  bodyLines,
  limitUsd,
  onCancel,
  onProceed,
}: AutoSubmitConfirmDialogProps) => {
  const { classes, cx } = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      classes={{ paper: classes.paper }}
      data-testid="auto-submit-confirm-dialog"
    >
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <div className={classes.titleGroup}>
            <span className={classes.titleIcon}>
              <FontAwesomeIcon icon={faBan} />
            </span>
            <Typography component="h2" className={classes.title}>
              {title}
            </Typography>
          </div>
          <span className={classes.divider} />
          {/* The settings page has no chat panel, so this stays a plain link
              until there is a help article to point it at. */}
          <a className={classes.help} href={HELP_URL}>
            <FontAwesomeIcon icon={faCircleInfo} />
            <Typography component="span" className={classes.helpText}>
              Help & FAQs
            </Typography>
          </a>
        </div>
        <button
          type="button"
          className={classes.close}
          aria-label="Close"
          onClick={onCancel}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <div className={classes.body}>
        {bodyLines.map(line => (
          <Typography key={line} component="span" className={classes.bodyText}>
            {line}
          </Typography>
        ))}
        <NoteV2
          description={
            <>
              <AutoSubmitLimitNote limitUsd={limitUsd} />
              <Typography component="span" className={classes.noteLine}>
                You can disable auto-submission anytime.
              </Typography>
            </>
          }
        />
      </div>

      <div className={classes.footer}>
        <button
          type="button"
          className={cx(classes.button, classes.cancelButton)}
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className={cx(classes.button, classes.proceedButton)}
          onClick={onProceed}
        >
          Proceed
        </button>
      </div>
    </Dialog>
  )
}
